<template lang="pug">
#changeLang.modal.modal-bottom.fade.modal-common(tabindex='-1' role='dialog' aria-labelledby='langLabel' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.modal-bottom-center(role='document')
    .modal-content
      .modal-header(@click="hideModal" :aria-label="$t('ui.cancel')")
        .icon
          i.fas.fa-arrow-left
        h5.modal-title {{ $t("ui.display_language") }}
      .modal-body 
        ul.list-group.setting
          template(v-for="item in languageList")
            li.list-group-item(:class="{ active: (item == language) }" @click="setLanguage(item)")
              span.lang-pic
                img(:src="'/images/lang/' + item + '.svg?v=12'")
              span {{ $t("language." + item) }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";

export default {
  data() {
    return {
      languageList: ["en", "cn", "vi", "th", "id", "kr", "jp", "tw"]
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    }
  },
  methods: {
    hideModal() {
      $("#changeLang").modal("hide");
    },
    setLanguage(lang) {
      this.$store.dispatch("layout/setLanguage", lang);
      EventBus.$emit("INVALIDATE");
      $("#changeLang").modal("hide");
    }
  }
}
</script>